import React from 'react';
import { FlightColumn } from '../../table/FlightTable';
import KeyUtils from '../../../common/util/KeyUtils';
import { FlightLevelBand, StandardFlightFieldType } from 'app/model/CORE';
import { ServiceFactory } from 'app/service/ServiceFactory';
import { notification } from 'antd';
import Utils from '../../../common/util/Utils';
import FlightUtils from '../../../common/util/FlightUtils';
import { FlightListPanel, FlightListPanelProps } from 'app/components/panels/flights/FlightListPanel';
import { GetFlightListImpactedByConvectionRequest } from 'app/model/SOL49';
import AppContext from 'app/common/context/AppContext';
import { Flex } from 'app/components/common/Flex';

interface ConvectionFlightListPanelProps extends FlightListPanelProps {
    flightLevelBand: FlightLevelBand;
    tvRefLocAirspaceId: string; //TODO might not be required
}

export class ConvectionFlightListPanel extends FlightListPanel<ConvectionFlightListPanelProps> {
    public static WIDTH = '85em';

    refreshFlightList = () => {
        if (
            !this.props.countType ||
            !this.props.tvId ||
            !this.props.trafficWindow?.from ||
            !this.props.trafficWindow?.to
        )
            return undefined;

        const request: GetFlightListImpactedByConvectionRequest = {
            display: this.props.countType,
            tvId: this.props.tvId,
            datasetDto: AppContext.getDataset(),
            fields: Utils.copyAndRemoveAllIfNeeded(FlightColumn.computeB2BFieldList(this.SIMPLE_FLIGHT_COLUMNS), [
                StandardFlightFieldType.PROPOSAL_CONTEXT,
                StandardFlightFieldType.PROPOSAL_INFORMATION,
            ]),
            //reply.fields = null;
            // includeForecastFlights: true,
            // trafficType: this.props.trafficType,
            // algorithm: FlightListAlgorithm.NM,
            timePeriod: this.props.trafficWindow,
            flightLevel: this.props.flightLevelBand,
            tvRefLocAirspaceId: this.props.tvRefLocAirspaceId,
        };
        ServiceFactory.sol49Service()
            .getFlightListImpactedByConvection(request)
            .then(reply => {
                if (reply.error) {
                    notification.error({ message: 'Error', description: reply.error.message, duration: 0 });
                } else {
                    let selection = [];
                    if (this.props.defaultSelectedFlights)
                        selection = reply.data.flights.filter(flight => {
                            return Utils.contains(
                                this.props.defaultSelectedFlights,
                                KeyUtils.FLIGHT_KEY_PROVIDER.getKey(flight),
                                FlightUtils.isSameFlight,
                            );
                        });
                    this.setState({ flights: reply.data.flights, selection: selection });
                }
            })
            .catch(reason => {
                notification.error({ message: 'Error', description: reason.message, duration: 0 });
            });
    };

    render() {
        return (
            <Flex direction={'vertical'} style={{ gap: '1em' }}>
                <Flex size={'1em'} style={{ alignSelf: 'center' }} className={'modal-title'}>
                    Impacted flights by convection
                </Flex>
                <Flex size={'1em'} style={{ alignSelf: 'center' }} className={'modal-title'}>
                    Traffic Volume: {this.props.tvId}
                </Flex>
                {super.render()}
            </Flex>
        );
    }
}
